import { flowDefinitionSchema, type FlowDefinition } from './types';

export interface SyncFlowResolveRequest {
  flowId: string;
  locale: string;
  surfaceId: string;
}

export interface SyncFlowSource {
  resolve(request: SyncFlowResolveRequest): FlowDefinition;
}

export function resolveSyncFlowDefinition(
  source: SyncFlowSource,
  request: SyncFlowResolveRequest,
): FlowDefinition {
  return flowDefinitionSchema.parse(source.resolve(request));
}

// Async flow-source: a net-new path alongside the sync one for flows whose
// definition is fetched at runtime (e.g. from an API) rather than bundled. The
// sync contract above is deliberately left untouched so the bundled flows keep
// resolving synchronously.
export interface AsyncFlowResolveRequest {
  flowId: string;
  locale: string;
  surfaceId: string;
}

export interface AsyncFlowSource {
  /** Stable, serializable values that identify the source's fetched/mapped output. */
  cacheKey: readonly unknown[];
  resolve(request: AsyncFlowResolveRequest): Promise<FlowDefinition>;
}

export async function resolveAsyncFlowDefinition(
  source: AsyncFlowSource,
  request: AsyncFlowResolveRequest,
): Promise<FlowDefinition> {
  return flowDefinitionSchema.parse(await source.resolve(request));
}
